import { render } from "./OptionList.vue?vue&type=template&id=62a91596&bindings={\"category\":\"props\"}"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"
script.render = render

export default script